"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var workspace_window_1 = require("./workspace-window");
var Workspace = /** @class */ (function () {
    function Workspace(_serverModel) {
        this._serverModel = _serverModel;
    }
    Workspace.prototype.getId = function () {
        return this._serverModel.id;
    };
    Workspace.prototype.setId = function (id) {
        this._serverModel.id = id;
    };
    Workspace.prototype.getName = function () {
        return this._serverModel.name;
    };
    Workspace.prototype.setName = function (name) {
        this._serverModel.name = name;
    };
    Workspace.prototype.getEikonInstanceId = function () {
        return this._serverModel.eikonInstanceId;
    };
    Workspace.prototype.setEikonInstanceId = function (id) {
        this._serverModel.eikonInstanceId = id;
    };
    Workspace.prototype.getEikonWorkspaceData = function () {
        if (this._serverModel.eikonWorkspace &&
            this._serverModel.eikonWorkspace.data) {
            return JSON.parse(this._serverModel.eikonWorkspace.data);
        }
        else {
            return {};
        }
    };
    Workspace.prototype.setEikonWorkspaceData = function (data) {
        if (!this._serverModel.eikonWorkspace) {
            this._serverModel.eikonWorkspace = { data: "" };
        }
        this._serverModel.eikonWorkspace.data = JSON.stringify(data);
    };
    Workspace.prototype.getRediPlusWindows = function () {
        if (this._serverModel.rediPlusWindows) {
            return JSON.parse(this._serverModel.rediPlusWindows);
        }
        else {
            return [];
        }
    };
    Workspace.prototype.setRediPlusWindows = function (windows) {
        this._serverModel.rediPlusWindows = JSON.stringify(windows);
    };
    Workspace.prototype.getAllWindows = function () {
        return this._serverModel.windows.map(function (serverModel) { return new workspace_window_1.WorkspaceWindow(serverModel); });
    };
    Workspace.prototype.getOrCreateWindow = function (name, id, defaultLayout, defaultData) {
        var workspaceWindow = this.getWindow(name, id);
        if (!workspaceWindow) {
            workspaceWindow = this.createWindow(name, id, defaultLayout, defaultData);
            this.setWindow(workspaceWindow);
        }
        else {
            workspaceWindow.setId(id);
            if (workspaceWindow.isDataEmpty()) {
                workspaceWindow.setData(defaultData);
            }
        }
        if (this.getName()) {
            workspaceWindow.setWorkspaceName(this.getName());
        }
        else if (workspaceWindow.getWorkspaceName()) {
            this.setName(workspaceWindow.getWorkspaceName());
        }
        return workspaceWindow;
    };
    Workspace.prototype.getWindow = function (name, id) {
        var _this = this;
        var serverModels = this._serverModel.windows.filter(function (serverModel) { return _this.areEqual(name, id, serverModel); });
        if (serverModels.length) {
            return new workspace_window_1.WorkspaceWindow(serverModels[0]);
        }
        else {
            return null;
        }
    };
    Workspace.prototype.createWindow = function (name, id, defaultLayout, defaultData) {
        return new workspace_window_1.WorkspaceWindow({
            id: id,
            name: name,
            workspaceId: this.getId(),
            workspaceName: this.getName(),
            layout: defaultLayout,
            isNewWindow: true,
            contents: {
                data: JSON.stringify(defaultData)
            }
        });
    };
    Workspace.prototype.setWindow = function (workspaceWindow) {
        var _this = this;
        this._serverModel.windows = this._serverModel.windows.filter(function (serverModel) {
            return !_this.areEqual(workspaceWindow.getName(), workspaceWindow.getId(), serverModel);
        });
        this._serverModel.windows.push(workspaceWindow.serverModel());
    };
    Workspace.prototype.areEqual = function (name, id, serverModel) {
        return (serverModel.name === name &&
            (serverModel.id ? serverModel.id === id : true));
    };
    Workspace.prototype.serverModel = function () {
        return this._serverModel;
    };
    return Workspace;
}());
exports.Workspace = Workspace;



//////////////////
// WEBPACK FOOTER
// /app/~/redi-workspaces-web-lib/dist/business/workspace.js
// module id = 136
// module chunks = 0